import "./styles.css";

const LION_CODES = {
	trxc: "01",
	fpva: "02",
	sbfh: "03",
	afqo: "04",
	nzjo: "05",
	qjjf: "06",
	yicc: "07",
	usie: "08",
	wpus: "09",
	cgch: "10",
	qahf: "11",
	kafn: "12",
	vqwp: "13",
};

const ASSET_BASE = "/assets";

/** Local diagnostic only. Keep disabled in production to preserve model caching. */
const DEV_AR_NO_CACHE = false;

document.querySelector("#app").innerHTML = `
  <main class="page-shell">
    <section class="hero" aria-labelledby="hero-title">
      <div class="hero__content">
        <img class="brand-lockup" src="${ASSET_BASE}/logos.png" alt="Bermuda and Photoplay" />
        <p class="hero__kicker">Frameless Production presents</p>

        <h1 class="hero__title" id="hero-title">
          <span class="gradient-text">Lions</span>
          <span>all round!</span>
        </h1>

        <div class="hero__copy accent-rule">
          <p>Share and celebrate yours <strong>with the whole pride.</strong></p>
          <p>Because the trophy may be one, <strong>but the people behind it are many.</strong></p>
        </div>

        <div class="hero-art" aria-hidden="true">
          <span class="spark spark--one"></span>
          <span class="spark spark--two"></span>
          <span class="spark spark--three"></span>
          <span class="spark spark--four"></span>
          <span class="spark spark--five"></span>
          <img src="${ASSET_BASE}/Lion%20Wireframe.png" alt="" />
        </div>

        <div class="hero__action">
          <a class="button button--primary is-disabled" id="ar-button" href="#" aria-label="Your shareable Lion is ready" aria-disabled="true" aria-describedby="ar-status"><img class="quick-look-pixel" src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" alt="" width="1" height="1" /></a>
          <p class="ar-status" id="ar-status" role="status" aria-live="polite"></p>
        </div>
      </div>
    </section>

    <section class="connect" aria-labelledby="connect-title">
      <div class="connect__inner">
        <div class="service-card">
          <p id="connect-title">Got an award-winning idea?<br />Let’s take it beyond the frame.</p>
        </div>

        <a class="button button--frameless" href="https://photoplay.co/creative-tech/" target="_blank" rel="noreferrer">
          <span>Discover Frameless Production</span>
        </a>

        <a class="button button--outline" href="mailto:facundo.martinelli@thebermuda.com?subject=Sydney%20office%20enquiry">
          <span>Contact our Sydney office</span>
          <span class="button__arrow" aria-hidden="true"></span>
        </a>

        <nav class="socials" aria-label="Social media">
          <a href="https://www.instagram.com/thebermudacompany/" target="_blank" rel="noreferrer" aria-label="Bermuda on Instagram">
            <img src="${ASSET_BASE}/mingcute_instagram-line.svg" alt="" />
          </a>
          <a href="https://www.linkedin.com/company/bermuda-lab/" target="_blank" rel="noreferrer" aria-label="Bermuda on LinkedIn">
            <img src="${ASSET_BASE}/Linkedin.svg" alt="" />
          </a>
        </nav>
      </div>
    </section>
  </main>
`;

const params = new URLSearchParams(window.location.search);
const code = (params.get("l") || "").toLowerCase().trim();
const lionId = LION_CODES[code] || null;
const useAvocadoTest = params.get("test") === "avocado";
const KNOWN_GOOD_GLB =
	"https://raw.githubusercontent.com/KhronosGroup/glTF-Sample-Models/master/2.0/Avocado/glTF-Binary/Avocado.glb";
const button = document.querySelector("#ar-button");
const status = document.querySelector("#ar-status");
const userAgent = navigator.userAgent || "";
const isIOS =
	/iPad|iPhone|iPod/.test(userAgent) ||
	(navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
const isAndroid = /Android/i.test(userAgent);
const isSecure =
	window.location.protocol === "https:" ||
	["localhost", "127.0.0.1"].includes(window.location.hostname);

function absoluteUrl(path) {
	return new URL(path, window.location.href).href;
}

/** Absolute model URL; in DEV appends a unique `v` so phone AR clients skip cache. */
function modelAssetUrl(path, bust = DEV_AR_NO_CACHE) {
	const url = new URL(path, window.location.href);
	if (bust) url.searchParams.set("v", String(Date.now()));
	return url.href;
}

function androidIntent(fileUrl) {
	const fallback = encodeURIComponent(window.location.href);
	return (
		`intent://arvr.google.com/scene-viewer/1.0?file=${encodeURIComponent(fileUrl)}&mode=ar_preferred&title=${encodeURIComponent("Grand Prix Lion")}` +
		`#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=${fallback};end;`
	);
}

function disableAr(message) {
	button.href = "#";
	button.classList.add("is-disabled");
	button.setAttribute("aria-disabled", "true");
	status.textContent = message;
}

function enableAr(message) {
	button.classList.remove("is-disabled");
	button.removeAttribute("aria-disabled");
	status.textContent = message;
}

async function modelExists(path) {
	try {
		const head = await fetch(path, { method: "HEAD", cache: "no-store" });
		if (head.ok) return true;

		const partial = await fetch(path, {
			method: "GET",
			headers: { Range: "bytes=0-0" },
			cache: "no-store",
		});
		return partial.ok || partial.status === 206;
	} catch {
		return false;
	}
}

async function prepareArExperience() {
	if (!lionId) {
		disableAr(
			"Open the personalised link from your email to view your Lion in AR.",
		);
		return;
	}

	// Existence checks use a stable URL; AR open uses a busted URL in DEV.
	const usdzPath = `/models/lion${lionId}.usdz`;
	const glbPath = `/models/lion${lionId}.glb`;
	const usdz = absoluteUrl(usdzPath);
	const glb = absoluteUrl(glbPath);

	if ((isIOS || isAndroid) && !isSecure) {
		disableAr("AR requires the secure HTTPS version of this page.");
		return;
	}

	if (isIOS) {
		if (!(await modelExists(usdz))) {
			disableAr(
				"We couldn’t load your Lion right now. Please try again shortly.",
			);
			return;
		}

		button.dataset.arKind = "ios";
		button.dataset.modelPath = usdzPath;
		button.href = modelAssetUrl(usdzPath);
		button.rel = "ar";
		button.setAttribute("aria-label", "View your Lion in augmented reality");
		enableAr(
			DEV_AR_NO_CACHE
				? "DEV: Opens in AR Quick Look (no model cache)."
				: "Opens in AR Quick Look.",
		);
		return;
	}

	if (isAndroid) {
		const androidModel = useAvocadoTest ? KNOWN_GOOD_GLB : glb;
		if (!(await modelExists(androidModel))) {
			disableAr(
				"We couldn’t load the AR model right now. Please try again shortly.",
			);
			return;
		}

		button.dataset.arKind = "android";
		button.dataset.modelPath = useAvocadoTest ? "" : glbPath;
		button.href = androidIntent(
			useAvocadoTest ? KNOWN_GOOD_GLB : modelAssetUrl(glbPath),
		);
		button.setAttribute("aria-label", "View your Lion in augmented reality");
		enableAr(
			useAvocadoTest
				? "Android diagnostic mode: opens the known-good Avocado model."
				: DEV_AR_NO_CACHE
					? "DEV: Opens in Google Scene Viewer (no model cache)."
					: "Opens in Google Scene Viewer.",
		);
		return;
	}

	button.dataset.arKind = "desktop";
	button.dataset.modelPath = glbPath;
	button.href = modelAssetUrl(glbPath);
	button.setAttribute("download", `grand-prix-lion-${lionId}.glb`);
	enableAr(
		DEV_AR_NO_CACHE
			? "DEV: download uses a cache-busted URL. Reopen on your phone for AR."
			: "On desktop, download the 3D Lion or reopen this link on your phone for AR.",
	);
}

button.addEventListener("click", (event) => {
	if (button.getAttribute("aria-disabled") === "true") {
		event.preventDefault();
		status.classList.add("is-visible");
		return;
	}

	// Refresh the bust token on every tap so a replaced GLB/USDZ is fetched again.
	if (!DEV_AR_NO_CACHE) return;

	const kind = button.dataset.arKind;
	const modelPath = button.dataset.modelPath;
	if (!modelPath) return;

	if (kind === "ios" || kind === "desktop") {
		button.href = modelAssetUrl(modelPath);
	} else if (kind === "android") {
		button.href = androidIntent(modelAssetUrl(modelPath));
	}
});

prepareArExperience().catch(() => {
	disableAr(
		"We couldn’t prepare the AR experience. Reload the page and try again.",
	);
});
